namespace e5 {
    export interface TextLoaderOptions extends AjaxLoaderOptions {

    }

    class TextLoader extends AbstractAjaxLoader<string, TextLoaderOptions>{
        protected defaultOptions(): SvgLoaderOptions {
            return {
                decoder: "text"
            }
        }
    }

    export interface LoaderOptionsMap {
        "text": TextLoaderOptions;
    }

    export interface LoaderMap {
        "text": TextLoader;
    }

    registerLoader("text", TextLoader);
}